const initialState = () => {
  return {
    applicantInfo: {
      firstName: "",
      lastName: "",
      phoneNumber: "",
      email: ""
    },
    eventInfo: {},
    banquetInquiryDetails: null,
    errors: {
      applicationError: {
        hasError: null,
        error: []
      },
      banquetInquiryError: {
        hasError: null,
        error: []
      },
      maintenanceError: {
        hasError: null,
        error: ""
      }
    }
  };
};

export default initialState;
